<section *removeIfUnauthorized="hasNESSAdmin">
  <h2 class="h4">Manage Supervisors</h2>
  <p-messages [(value)]="msgs" [enableService]="false"></p-messages>
  <ng-container *ngIf="{ supervisors: cgicSupervisors$ | async, nonsupers: cgicNonSupervisors$ | async } as personnel">
    <div class="my-3">
      <button type="button" (click)="onSaveChanges()" class="btn btn-active" aria-label="Save changes to supervisors">Save changes</button>
    </div>
    <div class="my-3">
      <p-pickList [source]="personnel.nonsupers" [target]="personnel.supervisors" [responsive]="true" sourceHeader="All Personnel" targetHeader="Supervisors" filterBy="FieldDivisionName" sourceFilterPlaceholder="Filter by field division" targetFilterPlaceholder="Filter by field division" ariaSourceFilterLabel="Filter by field division" ariaTargetFilterLabel="Filter by field division" rightButtonAriaLabel="Assign personnel as supervisor" leftButtonAriaLabel="Unassign personnel from supervisor" allRightButtonAriaLabel="Assign all personnel as supervisors" allLeftButtonAriaLabel="Unassign all personnel from supervisors" [showSourceControls]="false" [showTargetControls]="false" (onMoveToTarget)="onAddSupervisor($event)" (onMoveToSource)="onRemoveSupervisor($event)" [sourceStyle]="{'max-height': '20rem'}" [targetStyle]="{'max-height': '20rem'}">
        <ng-template let-item pTemplate="item">
          {{item.LastName}}, {{item.FirstName}} ({{ item.FieldDivisionName }})
        </ng-template>
        <ng-template pTemplate="emptymessagesource">
          <ng-container *ngIf="!loadingSupervisors && !loadingNonSupervisors;else loadingSupers">
            No personnel found.
          </ng-container>
          <ng-template #loadingSupers>Loading...</ng-template>
        </ng-template>
        <ng-template pTemplate="emptymessagetarget">
          <ng-container *ngIf="!loadingSupervisors && !loadingNonSupervisors;else loadingSupers">
            No supervisors found.
          </ng-container>
          <ng-template #loadingSupers>Loading...</ng-template>
        </ng-template>
      </p-pickList>
    </div>
  </ng-container>
</section>
